import React from "react";
import "./App.css";
import Header from "./components/Header.jsx";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home.jsx";
import About from "./pages/About.jsx";
import Projects from "./pages/Projects.jsx";
import Contact from "./pages/Contact.jsx";
import ThreeHero from "./components/ThreeHero.jsx";

function App() {
  return (
    <div className="site">
      <ThreeHero />
      <main className="container">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      {/* <footer className="footer">
        <div className="container">
          <p>© {new Date().getFullYear()} Sagar Krisha. All rights reserved.</p>
        </div>
      </footer> */}
    </div>
  );
}

export default App;
